import { UserAction } from "../actions";
// import { Alert } from "react-native"
import { Functions, ApiCaller, Variables } from "../../config";
import info from "../../components/info";
import { put, delay } from "redux-saga/effects";
import {
  CANCEL_SUBSCRIPTION,
  CHECK_ACCOUNT,
  CREATE_ACCOUNT,
  CREATE_LINK,
  DEACTIVE_USER,
  NOTTIFICATION,
  SUBSCRIPTION,
  UPDATE_PROFILE,
  USER,
} from "../../config/variables";
import AuthAction from "../actions/AuthAction";
import axios from "axios";

const userId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[2]
  ?.rmx_company_user?.id;

export default class userMiddleWarre {
  static *getUserMiddleWare(action) {
    const { id, params } = action;
    const qureyParams = new URLSearchParams(params).toString();

    const companyId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[1]
      ?.rmx_company?.id;
    try {
      let res = yield ApiCaller.Get(
        `rmx_companies/${companyId}/users?${qureyParams}`,
        {
          "Content-Type": "application/json",
        }
      );

      if (res.status == 200) {
        yield put(
          UserAction.getUserSuccess(res.data.data, null, res.data.meta)
        );

        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.getUserError());
      }
    } catch (e) {
      yield put(UserAction.getUserError());
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *createUserMiddleWare(action) {
    const { payload, cb, params } = action;
    const companyId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[1]
      ?.rmx_company?.id;
    let formData = new FormData();
    for (const key in payload) {
      formData.append(key, payload[key]);
    }

    try {
      let res = yield ApiCaller.Post(
        `rmx_companies/${companyId}/users`,
        formData,
        {
          "Content-Type": "application/json",
        }
      );

      if (res.status == 201) {
        cb() && cb();
        yield put(UserAction.getUserSuccess(res.data.data, null));
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.createUserError());
      }
    } catch (e) {
      yield put(UserAction.createUserError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *getUserDetailMiddleWare(action) {
    const { userId, cb } = action;
    const companyId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[1]
      ?.rmx_company?.id;
    try {
      let res = yield ApiCaller.Get(
        `rmx_companies/${companyId}/users/${userId}`,
        {
          "Content-Type": "application/json",
        }
      );

      if (res.status == 200) {
        yield put(UserAction.getUserDetailSuccess(res.data.data.user));
        cb() && cb();
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.getUserDetailError());
      }
    } catch (e) {
      yield put(UserAction.getUserDetailError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *getCompanyDetails(action) {
    const { userId, cb } = action;
    const companyId = JSON.parse(
      localStorage.getItem("trkr_contractor_auth")
    )?.[1]?.contractor?.id;

    try {
      let res = yield ApiCaller.Get(`contractors/${companyId}`, {
        "Content-Type": "application/json",
      });

      if (res.status == 200) {
        yield put(UserAction.getCompanyDetailSuccess(res.data.data));
        cb() && cb();
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else if (res.status == 401) {
        window.localStorage.clear();
        window.location.reload();
      } else {
        yield put(UserAction.getCompanyDetailError());
      }
    } catch (e) {
      yield put(UserAction.getCompanyDetailError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *getLocationMiddleWare(action) {
    const { cb } = action;
    const companyId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[1]
      ?.rmx_company?.id;
    try {
      let res = yield ApiCaller.Get(`rmx_companies/${companyId}/locations`, {
        "Content-Type": "application/json",
      });

      if (res.status == 200) {
        yield put(UserAction.getLocationSuccess(res.data.data));
        cb() && cb();
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.getLocationError());
      }
    } catch (e) {
      yield put(UserAction.getLocationError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }
  static *getCardsMiddleWare(action) {
    const { cb, params, route } = action;
    const qureyParams = new URLSearchParams(params).toString();
    const companyId = JSON.parse(
      localStorage.getItem("trkr_contractor_auth")
    )?.[1]?.contractor?.id;
    console.log("ROUTE==>", route);

    try {
      let res = yield ApiCaller.Get(
        `contractors/${companyId}/stripe/${route}?${qureyParams}`,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        yield put(UserAction.getCardsSuccess(res.data.data, res.data.meta));
        cb() && cb();
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.getLocationError());
      }
    } catch (e) {
      yield put(UserAction.getLocationError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *createLocationMiddleWare(action) {
    const { payload, cb } = action;
    const companyId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[1]
      ?.rmx_company?.id;
    const signComId = JSON.parse(localStorage.getItem("companyInfo"))?.id;
    try {
      let res = yield ApiCaller.Post(
        `rmx_companies/${signComId ? signComId : companyId}/locations`,
        { location: [payload] },
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 201) {
        yield put(UserAction.createLocationSuccess(res.data.data[0]));
        cb() && cb();
        info("success", "Plant added successfully");
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.createLocationError());
      }
    } catch (e) {
      yield put(UserAction.createLocationError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *deleteLocationMiddleWare(action) {
    const { id, cb } = action;
    const companyId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[1]
      ?.rmx_company?.id;
    try {
      let res = yield ApiCaller.Delete(
        `rmx_companies/${companyId}/locations/${id}`,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 204) {
        yield put(UserAction.deleteLocationSuccess(id));
        cb() && cb();
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.deleteLocationError());
      }
    } catch (e) {
      yield put(UserAction.deleteLocationError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *updateLocationMiddleWare(action) {
    const { id, cb, body } = action;
    const companyId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[1]
      ?.rmx_company?.id;
    try {
      let res = yield ApiCaller.Put(
        `rmx_companies/${companyId}/locations/${id}`,
        body,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        yield put(UserAction.UpdateLocationSuccess(id, res.data.data));
        cb() && cb();
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.UpdateLocationError());
      }
    } catch (e) {
      yield put(UserAction.UpdateLocationError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *updateAssetsMiddleWare(action) {
    const { id, cb, body } = action;
    const companyId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[1]
      ?.rmx_company?.id;
    const payload = {};
    if (body.cover || body.logo) {
      if (body.cover) {
        payload.cover = body.cover;
      }
      if (body.logo) {
        payload.logo = body.logo;
      }
    } else {
      payload.store_name = body.rmx_company_asset.store_name;
      payload.description = body.rmx_company_asset?.description;
    }
    let formData = new FormData();
    for (const key in payload) {
      formData.append(key, payload[key]);
    }

    try {
      let res = yield ApiCaller.Put(
        `rmx_companies/${companyId}/assets/${id}`,
        body.cover || body.logo ? formData : payload,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        yield put(UserAction.updateAssetsSuccess(id, res.data.data));
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
        if (body.cover) {
          info("success", "Cover Updated Successfully! ");
          cb() && cb();

          return;
        }
        if (body.logo) {
          info("success", "Logo Updated Successfully! ");
          cb() && cb();

          return;
        }
        if (!body.logo || !body.cover) {
          info("success", "Store Information Updated Successfully! ");
          cb() && cb();

          return;
        }
      } else {
        yield put(UserAction.updateAssetsError());
      }
    } catch (e) {
      yield put(UserAction.updateAssetsError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *updateBusinessInfoMiddleare(action) {
    const { id, cb, body } = action;
    const companyId = JSON.parse(
      localStorage.getItem("trkr_contractor_auth")
    )?.[1]?.contractor?.id;
    let formData = new FormData();
    formData.append("image", body.image);
    try {
      let res = yield ApiCaller.Put(`contractors/${companyId}`, formData, {
        "Content-Type": "application/json",
      });
      if (res.status == 200) {
        yield put(UserAction.getCompantDetailReq());
        info("success", "Image Updated Successfully!");
        cb() && cb();
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.updateAssetsError());
      }
    } catch (e) {
      yield put(UserAction.updateAssetsError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *updateProfileInfoMiddleare(action) {
    const { id, cb, body, active } = action;
    const companyId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[1]
      ?.rmx_company?.id;
    const uId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[2]
      ?.rmx_company_user?.id;
    const url = active
      ? `rmx_companies/${companyId}/users/${
          id ? id : uId
        }/${active.toLowerCase()}`
      : `rmx_companies/${companyId}/users/${id ? id : uId}`;
    const payload = {};
    if (!body.image?.medium) {
      payload.image = body.image;
      delete body.id;
    }
    let formData = new FormData();
    for (const key in payload) {
      formData.append(key, payload[key]);
    }
    try {
      let res = yield ApiCaller.Put(
        url,
        !!(!body.image?.medium && !body.id) ? formData : body,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        if (cb) {
          cb();
        }
        info("success", "Contact information updated successfully!");
        if (active) {
          info("success", "Employee status change successfully!");
        }
        if (body?.image?.name) {
          info("success", "Image Updated Successfully!");
        }

        yield put(UserAction.updateProfileInfoSuccess(id, res.data.data.user));
        yield put(UserAction.getUserSuccess(res.data.data, id));
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.updateProfileInfoError());
      }
    } catch (e) {
      yield put(UserAction.updateProfileInfoError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *createAssetsMiddleare(action) {
    const { cb, body } = action;
    const companyId = JSON.parse(localStorage.getItem("companyInfo"))?.id;
    const payload = {
      ...body,
    };
    if (body.cover) {
      payload.cover = body.cover;
    }
    if (body.logo) {
      payload.logo = body.logo;
    }
    let formData = new FormData();
    for (const key in payload) {
      formData.append(key, payload[key]);
    }
    try {
      let res = yield ApiCaller.Post(
        `rmx_companies/${companyId}/assets`,
        body.cover || body.logo ? formData : body,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 201) {
        localStorage.setItem("assets", JSON.stringify(res.data.data));
        if (cb) {
          cb();
        }

        yield put(UserAction.createAssetsSuccess(res.data.data.user));
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.createAssetsError());
      }
    } catch (e) {
      yield put(UserAction.createAssetsError(e));
    }
  }
  static *deleteCardMiddleware(action) {
    const { params, cb, body, cardId, radioValue } = action;

    const companyId = JSON.parse(
      localStorage.getItem("trkr_contractor_auth")
    )?.[1]?.contractor?.id;
    try {
      let res = yield ApiCaller.Delete(
        `contractors/${companyId}/stripe/cards/${cardId}`,
        body,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        yield put(UserAction.getCardsReq(params, radioValue));
        cb() && cb();
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.updateAssetsError());
      }
    } catch (e) {
      yield put(UserAction.updateAssetsError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *setDefaultCardMiddleware(action) {
    const { id, cb, body, cardId } = action;

    const companyId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[1]
      ?.rmx_company?.id;
    try {
      let res = yield ApiCaller.Put(
        `rmx_companies/${companyId}/stripe/cards/${cardId}/default`,
        {},
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        yield put(UserAction.getCardsReq());
        info("success", "Card set default successfully");
        cb() && cb();
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.updateAssetsError());
      }
    } catch (e) {
      yield put(UserAction.updateAssetsError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }
  static *getAddressMiddleware(action) {
    const { cb, params } = action;
    const qureyParams = new URLSearchParams(params).toString();
    const companyId = JSON.parse(
      localStorage.getItem("trkr_contractor_auth")
    )?.[1]?.contractor?.id;
    try {
      let res = yield ApiCaller.Get(
        `contractors/${companyId}/addresses?${qureyParams}`,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        yield put(UserAction.getAddressSuccess(res.data.data, res.data.meta));
        // cb() && cb();
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.getAddressError());
      }
    } catch (e) {
      yield put(UserAction.getAddressError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }
  static *updateAddressMiddleware(action) {
    const { cb, id, route, payload } = action;
    const companyId = JSON.parse(
      localStorage.getItem("trkr_contractor_auth")
    )?.[1]?.contractor?.id;
    const URL =
      route !== null
        ? `contractors/${companyId}/addresses/${id}/${route}`
        : `contractors/${companyId}/addresses/${id}`;

    try {
      let res = yield ApiCaller.Put(URL, payload, {
        "Content-Type": "application/json",
      });
      if (res.status == 200) {
        yield put(UserAction.getAddressReq(res.data.meta));
        info("success", "Address Information Updated Successfully!");
        cb() && cb();
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.updateAddressError());
      }
    } catch (e) {
      yield put(UserAction.updateAddressError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *getGeoLocationMiddleware(action) {
    const { cb, payload } = action;

    const companyId = JSON.parse(
      localStorage.getItem("trkr_contractor_auth")
    )?.[1]?.contractor?.id;
    const qureyParams = new URLSearchParams(payload).toString();
    try {
      let res = yield axios.get(
        `https://maps.googleapis.com/maps/api/geocode/json?${qureyParams}`,
        {
          headers: {
            "x-client-data":
              "CJG2yQEIpbbJAQjBtskBCKmdygEInvnLAQjnhMwBCNKPzAEIhpbMARiOnssB",

            origin: "http://app.stg.surface-tech.com",
            referer: "http://app.stg.surface-tech.com/",
            "sec-fetch-mode": "cors",
            "sec-fetch-site": "cross-site",
          },
        }
      );
      console.log("res_address", res);
      if (res?.status == 200) {
        cb() && cb();
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.getGeoLocationError());
      }
    } catch (e) {
      yield put(UserAction.getGeoLocationError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *createAddressMiddleware(action) {
    const { cb, payload, params } = action;

    const companyId = JSON.parse(
      localStorage.getItem("trkr_contractor_auth")
    )?.[1]?.contractor?.id;
    try {
      let res = yield ApiCaller.Post(
        `contractors/${companyId}/addresses`,
        payload,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 201) {
        cb() && cb();
        yield put(UserAction.getAddressReq(params));
        info("success", "Address Added Successfully!");

        yield put(UserAction.createAddressSuccess());

        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.createAddressError());
      }
    } catch (e) {
      yield put(UserAction.createAddressError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *downloadReciptMiddleware(action) {
    const { cb, payload, orderId } = action;

    try {
      let res = yield ApiCaller.Post(
        `orders/${orderId}/receipt`,
        { report_details: payload },
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        window.open(res.data.data.attachment, "_blank");
        cb() && cb();
        // yield put(UserAction.getAddressReq(params));

        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.downloadReciptError());
      }
    } catch (e) {
      yield put(UserAction.downloadReciptError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *shareReciptMiddleware(action) {
    const { cb, payload, orderId } = action;

    try {
      let res = yield ApiCaller.Post(
        `orders/${orderId}/email_receipt`,
        { report_details: { ...payload } },
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        cb() && cb();
        // yield put(UserAction.getAddressReq(params));
        info("success", "Receipt has been emailed to the recipients");

        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.downloadReciptError());
      }
    } catch (e) {
      yield put(UserAction.downloadReciptError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *createTokenMiddleware(action) {
    const { cb, payload, callback } = action;
    console.log("card_payload==>", payload);

    const params = new URLSearchParams();
    if (payload.currency) {
      for (var key in payload) {
        params.append(`bank_account[${key}]`, payload[key]);
      }
    } else {
      for (var key in payload) {
        params.append(`card[${key}]`, payload[key]);
      }
    }

    // params.append("card[exp_month]", 12);
    // params.append("card[exp_year]", 22);
    // params.append("card[cvc]", 123);
    // params.append("card[number]", 4242424242424242);
    let res;
    try {
      res = yield axios.post("https://api.stripe.com/v1/tokens", params, {
        headers: {
          abc: "Bearer sk_test_NNyixqopBsFDglopAkCwvFrN",
        },
      });
      if (res.status == 200) {
        // console.log('responseee==>',res)
        if (payload.currency) {
          yield put(
            UserAction.createBankAccountReq({ token: res.data.id }, cb)
          );
        } else {
          yield put(UserAction.createCardReq({ token: res.data.id }, cb));
        }
        // cb() && cb();
        // yield put(UserAction.getAddressReq(params));

        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        callback();
        info("error", res.data.error.code);
        yield put(UserAction.createTokenError());
      }
    } catch (e) {
      yield put(UserAction.createTokenError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *createCardMiddleware(action) {
    const { cb, payload, orderId } = action;
    const companyId = JSON.parse(
      localStorage.getItem("trkr_contractor_auth")
    )?.[1]?.contractor?.id;
    console.log("CALL_BACK==>", cb);

    let res;
    try {
      res = yield ApiCaller.Post(
        `contractors/${companyId}/stripe/cards`,
        payload,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        console.log("res_status==>", res);
        cb() && cb();
        // yield put(UserAction.getAddressReq(params));
        // info("success", "Receipt has been emailed to the recipients");

        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.createCardSuccess());
      }
    } catch (e) {
      yield put(UserAction.createCardError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *createBankAccount(action) {
    const { cb, payload, orderId } = action;
    const companyId = JSON.parse(
      localStorage.getItem("trkr_contractor_auth")
    )?.[1]?.contractor?.id;
    console.log("CALL_BACK==>", cb);

    let res;
    try {
      res = yield ApiCaller.Post(
        `contractors/${companyId}/stripe/bank_accounts`,
        payload,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        cb() && cb();
        // yield put(UserAction.getAddressReq(params));
        // info("success", "Receipt has been emailed to the recipients");

        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.createBankAccountError());
      }
    } catch (e) {
      yield put(UserAction.createBankAccountError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *verifyBankAccount(action) {
    const { cb, payload, bankId } = action;
    const companyId = JSON.parse(
      localStorage.getItem("trkr_contractor_auth")
    )?.[1]?.contractor?.id;

    let res;
    try {
      res = yield ApiCaller.Put(
        `contractors/${companyId}/stripe/bank_accounts/${bankId}/verification`,
        payload,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        cb() && cb();
        // yield put(UserAction.getAddressReq(params));
        // info("success", "Receipt has been emailed to the recipients");

        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.verifyBankAccountError());
      }
    } catch (e) {
      yield put(UserAction.verifyBankAccountError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }
}
